jQuery(document).ready( function() {

	var product_title = jQuery('#form-wrapper').attr('product_title');

	if(product_title != null) {
		jQuery('select[name=your-product]').val(product_title);
	}

});
